const data = [
  {
    c_id: 110000,
    c_title: "北京市",
    c_level: 1,
    c_prentId: 0,
    c_special: 1,
    c_sortOrder: 76
    // children: [
    //   {
    //     c_id: 110000,
    //     c_title: "北京市",
    //     c_level: 2,
    //     c_prentId: 110000,
    //     c_special: 0,
    //     c_sortOrder: 761
    //   }
    // ]
  },
  {
    c_id: 310000,
    c_title: "上海市",
    c_level: 1,
    c_prentId: 0,
    c_special: 1,
    c_sortOrder: 69
    // children: [
    //   {
    //     c_id: 310000,
    //     c_title: "上海市",
    //     c_level: 2,
    //     c_prentId: 310000,
    //     c_special: 0,
    //     c_sortOrder: 691
    //   }
    // ]
  },
  {
    c_id: 500000,
    c_title: "重庆市",
    c_level: 1,
    c_prentId: 0,
    c_special: 1,
    c_sortOrder: 90
    // children: [
    //   {
    //     c_id: 500000,
    //     c_title: "重庆市",
    //     c_level: 2,
    //     c_prentId: 500000,
    //     c_special: 0,
    //     c_sortOrder: 901
    //   }
    // ]
  },
  {
    c_id: 120000,
    c_title: "天津市",
    c_level: 1,
    c_prentId: 0,
    c_special: 1,
    c_sortOrder: 77
    // children: [
    //   {
    //     c_id: 120000,
    //     c_title: "天津市",
    //     c_level: 2,
    //     c_prentId: 120000,
    //     c_special: 0,
    //     c_sortOrder: 771
    //   }
    // ]
  },
  {
    c_id: 370000,
    c_title: "山东省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 70,
    children: [
      {
        c_id: 370100,
        c_title: "济南市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 370300,
        c_title: "淄博市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 370500,
        c_title: "东营市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 72
      },
      {
        c_id: 370700,
        c_title: "潍坊市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 73
      },
      {
        c_id: 370900,
        c_title: "泰安市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 74
      },
      {
        c_id: 371400,
        c_title: "德州市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 75
      },
      {
        c_id: 370600,
        c_title: "烟台市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 76
      },
      {
        c_id: 370200,
        c_title: "青岛市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 77
      },
      {
        c_id: 371700,
        c_title: "菏泽市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 78
      },
      {
        c_id: 370400,
        c_title: "枣庄市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 370800,
        c_title: "济宁市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 371000,
        c_title: "威海市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 371100,
        c_title: "日照市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 371200,
        c_title: "莱芜市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 371300,
        c_title: "临沂市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 371500,
        c_title: "聊城市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 371600,
        c_title: "滨州市",
        c_level: 2,
        c_prentId: 370000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 320000,
    c_title: "江苏省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 71,
    children: [
      {
        c_id: 320100,
        c_title: "南京市",
        c_level: 2,
        c_prentId: 320000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 320800,
        c_title: "淮安市",
        c_level: 2,
        c_prentId: 320000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 320300,
        c_title: "徐州市",
        c_level: 2,
        c_prentId: 320000,
        c_special: 0,
        c_sortOrder: 72
      },
      {
        c_id: 320600,
        c_title: "南通市",
        c_level: 2,
        c_prentId: 320000,
        c_special: 0,
        c_sortOrder: 73
      },
      {
        c_id: 321000,
        c_title: "扬州市",
        c_level: 2,
        c_prentId: 320000,
        c_special: 0,
        c_sortOrder: 74
      },
      {
        c_id: 320500,
        c_title: "苏州市",
        c_level: 2,
        c_prentId: 320000,
        c_special: 0,
        c_sortOrder: 75
      },
      {
        c_id: 320200,
        c_title: "无锡市",
        c_level: 2,
        c_prentId: 320000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 320400,
        c_title: "常州市",
        c_level: 2,
        c_prentId: 320000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 320700,
        c_title: "连云港市",
        c_level: 2,
        c_prentId: 320000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 320900,
        c_title: "盐城市",
        c_level: 2,
        c_prentId: 320000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 321100,
        c_title: "镇江市",
        c_level: 2,
        c_prentId: 320000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 321200,
        c_title: "泰州市",
        c_level: 2,
        c_prentId: 320000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 321300,
        c_title: "宿迁市",
        c_level: 2,
        c_prentId: 320000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 330000,
    c_title: "浙江省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 72,
    children: [
      {
        c_id: 330100,
        c_title: "杭州市",
        c_level: 2,
        c_prentId: 330000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 330200,
        c_title: "宁波市",
        c_level: 2,
        c_prentId: 330000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 330700,
        c_title: "金华市",
        c_level: 2,
        c_prentId: 330000,
        c_special: 0,
        c_sortOrder: 72
      },
      {
        c_id: 330500,
        c_title: "湖州市",
        c_level: 2,
        c_prentId: 330000,
        c_special: 0,
        c_sortOrder: 73
      },
      {
        c_id: 330300,
        c_title: "温州市",
        c_level: 2,
        c_prentId: 330000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 330400,
        c_title: "嘉兴市",
        c_level: 2,
        c_prentId: 330000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 330600,
        c_title: "绍兴市",
        c_level: 2,
        c_prentId: 330000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 330800,
        c_title: "衢州市",
        c_level: 2,
        c_prentId: 330000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 330900,
        c_title: "舟山市",
        c_level: 2,
        c_prentId: 330000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 331000,
        c_title: "台州市",
        c_level: 2,
        c_prentId: 330000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 331100,
        c_title: "丽水市",
        c_level: 2,
        c_prentId: 330000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 360000,
    c_title: "江西省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 73,
    children: [
      {
        c_id: 360100,
        c_title: "南昌市",
        c_level: 2,
        c_prentId: 360000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 360800,
        c_title: "吉安市",
        c_level: 2,
        c_prentId: 360000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 360200,
        c_title: "景德镇市",
        c_level: 2,
        c_prentId: 360000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 360300,
        c_title: "萍乡市",
        c_level: 2,
        c_prentId: 360000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 360400,
        c_title: "九江市",
        c_level: 2,
        c_prentId: 360000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 360500,
        c_title: "新余市",
        c_level: 2,
        c_prentId: 360000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 360600,
        c_title: "鹰潭市",
        c_level: 2,
        c_prentId: 360000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 360700,
        c_title: "赣州市",
        c_level: 2,
        c_prentId: 360000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 360900,
        c_title: "宜春市",
        c_level: 2,
        c_prentId: 360000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 361000,
        c_title: "抚州市",
        c_level: 2,
        c_prentId: 360000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 361100,
        c_title: "上饶市",
        c_level: 2,
        c_prentId: 360000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 340000,
    c_title: "安徽省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 74,
    children: [
      {
        c_id: 340100,
        c_title: "合肥市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 340200,
        c_title: "芜湖市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 340300,
        c_title: "蚌埠市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 340400,
        c_title: "淮南市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 340500,
        c_title: "马鞍山市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 340600,
        c_title: "淮北市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 340700,
        c_title: "铜陵市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 340800,
        c_title: "安庆市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 341000,
        c_title: "黄山市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 341100,
        c_title: "滁州市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 341200,
        c_title: "阜阳市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 341300,
        c_title: "宿州市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 341500,
        c_title: "六安市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 341600,
        c_title: "亳州市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 341700,
        c_title: "池州市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 341800,
        c_title: "宣城市",
        c_level: 2,
        c_prentId: 340000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 350000,
    c_title: "福建省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 75,
    children: [
      {
        c_id: 350100,
        c_title: "福州市",
        c_level: 2,
        c_prentId: 350000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 350200,
        c_title: "厦门市",
        c_level: 2,
        c_prentId: 350000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 350300,
        c_title: "莆田市",
        c_level: 2,
        c_prentId: 350000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 350400,
        c_title: "三明市",
        c_level: 2,
        c_prentId: 350000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 350500,
        c_title: "泉州市",
        c_level: 2,
        c_prentId: 350000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 350600,
        c_title: "漳州市",
        c_level: 2,
        c_prentId: 350000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 350700,
        c_title: "南平市",
        c_level: 2,
        c_prentId: 350000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 350800,
        c_title: "龙岩市",
        c_level: 2,
        c_prentId: 350000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 350900,
        c_title: "宁德市",
        c_level: 2,
        c_prentId: 350000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 140000,
    c_title: "山西省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 78,
    children: [
      {
        c_id: 140100,
        c_title: "太原市",
        c_level: 2,
        c_prentId: 140000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 140600,
        c_title: "朔州市",
        c_level: 2,
        c_prentId: 140000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 141000,
        c_title: "临汾市",
        c_level: 2,
        c_prentId: 140000,
        c_special: 0,
        c_sortOrder: 72
      },
      {
        c_id: 140500,
        c_title: "晋城市",
        c_level: 2,
        c_prentId: 140000,
        c_special: 0,
        c_sortOrder: 73
      },
      {
        c_id: 140300,
        c_title: "阳泉市",
        c_level: 2,
        c_prentId: 140000,
        c_special: 0,
        c_sortOrder: 74
      },
      {
        c_id: 140200,
        c_title: "大同市",
        c_level: 2,
        c_prentId: 140000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 140400,
        c_title: "长治市",
        c_level: 2,
        c_prentId: 140000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 140700,
        c_title: "晋中市",
        c_level: 2,
        c_prentId: 140000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 140800,
        c_title: "运城市",
        c_level: 2,
        c_prentId: 140000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 140900,
        c_title: "忻州市",
        c_level: 2,
        c_prentId: 140000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 141100,
        c_title: "吕梁市",
        c_level: 2,
        c_prentId: 140000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 130000,
    c_title: "河北省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 79,
    children: [
      {
        c_id: 130100,
        c_title: "石家庄市",
        c_level: 2,
        c_prentId: 130000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 131000,
        c_title: "廊坊市",
        c_level: 2,
        c_prentId: 130000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 130900,
        c_title: "沧州市",
        c_level: 2,
        c_prentId: 130000,
        c_special: 0,
        c_sortOrder: 72
      },
      {
        c_id: 130200,
        c_title: "唐山市",
        c_level: 2,
        c_prentId: 130000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 130300,
        c_title: "秦皇岛市",
        c_level: 2,
        c_prentId: 130000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 130400,
        c_title: "邯郸市",
        c_level: 2,
        c_prentId: 130000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 130500,
        c_title: "邢台市",
        c_level: 2,
        c_prentId: 130000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 130600,
        c_title: "保定市",
        c_level: 2,
        c_prentId: 130000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 130700,
        c_title: "张家口市",
        c_level: 2,
        c_prentId: 130000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 130800,
        c_title: "承德市",
        c_level: 2,
        c_prentId: 130000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 131100,
        c_title: "衡水市",
        c_level: 2,
        c_prentId: 130000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 150000,
    c_title: "内蒙古",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 80,
    children: [
      {
        c_id: 150100,
        c_title: "呼和浩特市",
        c_level: 2,
        c_prentId: 150000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 150200,
        c_title: "包头市",
        c_level: 2,
        c_prentId: 150000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 150300,
        c_title: "乌海市",
        c_level: 2,
        c_prentId: 150000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 150400,
        c_title: "赤峰市",
        c_level: 2,
        c_prentId: 150000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 150500,
        c_title: "通辽市",
        c_level: 2,
        c_prentId: 150000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 150600,
        c_title: "鄂尔多斯市",
        c_level: 2,
        c_prentId: 150000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 150700,
        c_title: "呼伦贝尔市",
        c_level: 2,
        c_prentId: 150000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 150800,
        c_title: "巴彦淖尔市",
        c_level: 2,
        c_prentId: 150000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 150900,
        c_title: "乌兰察布市",
        c_level: 2,
        c_prentId: 150000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 152200,
        c_title: "兴安盟",
        c_level: 2,
        c_prentId: 150000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 152500,
        c_title: "锡林郭勒盟",
        c_level: 2,
        c_prentId: 150000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 152900,
        c_title: "阿拉善盟",
        c_level: 2,
        c_prentId: 150000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 220000,
    c_title: "吉林省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 81,
    children: [
      {
        c_id: 220100,
        c_title: "长春市",
        c_level: 2,
        c_prentId: 220000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 220200,
        c_title: "吉林市",
        c_level: 2,
        c_prentId: 220000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 220300,
        c_title: "四平市",
        c_level: 2,
        c_prentId: 220000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 220400,
        c_title: "辽源市",
        c_level: 2,
        c_prentId: 220000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 220500,
        c_title: "通化市",
        c_level: 2,
        c_prentId: 220000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 220600,
        c_title: "白山市",
        c_level: 2,
        c_prentId: 220000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 220700,
        c_title: "松原市",
        c_level: 2,
        c_prentId: 220000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 220800,
        c_title: "白城市",
        c_level: 2,
        c_prentId: 220000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 222400,
        c_title: "延边朝鲜族自治州",
        c_level: 2,
        c_prentId: 220000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 210000,
    c_title: "辽宁省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 82,
    children: [
      {
        c_id: 210100,
        c_title: "沈阳市",
        c_level: 2,
        c_prentId: 210000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 210200,
        c_title: "大连市",
        c_level: 2,
        c_prentId: 210000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 210600,
        c_title: "丹东市",
        c_level: 2,
        c_prentId: 210000,
        c_special: 0,
        c_sortOrder: 72
      },
      {
        c_id: 210800,
        c_title: "营口市",
        c_level: 2,
        c_prentId: 210000,
        c_special: 0,
        c_sortOrder: 73
      },
      {
        c_id: 210700,
        c_title: "锦州市",
        c_level: 2,
        c_prentId: 210000,
        c_special: 0,
        c_sortOrder: 74
      },
      {
        c_id: 210300,
        c_title: "鞍山市",
        c_level: 2,
        c_prentId: 210000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 210400,
        c_title: "抚顺市",
        c_level: 2,
        c_prentId: 210000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 210500,
        c_title: "本溪市",
        c_level: 2,
        c_prentId: 210000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 210900,
        c_title: "阜新市",
        c_level: 2,
        c_prentId: 210000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 211000,
        c_title: "辽阳市",
        c_level: 2,
        c_prentId: 210000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 211100,
        c_title: "盘锦市",
        c_level: 2,
        c_prentId: 210000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 211200,
        c_title: "铁岭市",
        c_level: 2,
        c_prentId: 210000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 211300,
        c_title: "朝阳市",
        c_level: 2,
        c_prentId: 210000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 211400,
        c_title: "葫芦岛市",
        c_level: 2,
        c_prentId: 210000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 230000,
    c_title: "黑龙江省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 83,
    children: [
      {
        c_id: 230100,
        c_title: "哈尔滨市",
        c_level: 2,
        c_prentId: 230000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 230200,
        c_title: "齐齐哈尔市",
        c_level: 2,
        c_prentId: 230000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 231000,
        c_title: "牡丹江市",
        c_level: 2,
        c_prentId: 230000,
        c_special: 0,
        c_sortOrder: 72
      },
      {
        c_id: 230800,
        c_title: "佳木斯市",
        c_level: 2,
        c_prentId: 230000,
        c_special: 0,
        c_sortOrder: 73
      },
      {
        c_id: 230300,
        c_title: "鸡西市",
        c_level: 2,
        c_prentId: 230000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 230400,
        c_title: "鹤岗市",
        c_level: 2,
        c_prentId: 230000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 230500,
        c_title: "双鸭山市",
        c_level: 2,
        c_prentId: 230000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 230600,
        c_title: "大庆市",
        c_level: 2,
        c_prentId: 230000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 230700,
        c_title: "伊春市",
        c_level: 2,
        c_prentId: 230000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 230900,
        c_title: "七台河市",
        c_level: 2,
        c_prentId: 230000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 231100,
        c_title: "黑河市",
        c_level: 2,
        c_prentId: 230000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 231200,
        c_title: "绥化市",
        c_level: 2,
        c_prentId: 230000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 232700,
        c_title: "大兴安岭地区",
        c_level: 2,
        c_prentId: 230000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 410000,
    c_title: "河南省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 84,
    children: [
      {
        c_id: 410100,
        c_title: "郑州市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 411300,
        c_title: "南阳市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 411400,
        c_title: "商丘市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 72
      },
      {
        c_id: 411700,
        c_title: "驻马店市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 73
      },
      {
        c_id: 410700,
        c_title: "新乡市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 74
      },
      {
        c_id: 410300,
        c_title: "洛阳市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 75
      },
      {
        c_id: 410200,
        c_title: "开封市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 410400,
        c_title: "平顶山市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 410500,
        c_title: "安阳市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 410600,
        c_title: "鹤壁市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 410800,
        c_title: "焦作市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 410900,
        c_title: "濮阳市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 411000,
        c_title: "许昌市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 411100,
        c_title: "漯河市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 411200,
        c_title: "三门峡市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 411500,
        c_title: "信阳市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 411600,
        c_title: "周口市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 419001,
        c_title: "济源市",
        c_level: 2,
        c_prentId: 410000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 430000,
    c_title: "湖南省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 85,
    children: [
      {
        c_id: 430100,
        c_title: "长沙市",
        c_level: 2,
        c_prentId: 430000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 431000,
        c_title: "郴州市",
        c_level: 2,
        c_prentId: 430000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 430200,
        c_title: "株洲市",
        c_level: 2,
        c_prentId: 430000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 430300,
        c_title: "湘潭市",
        c_level: 2,
        c_prentId: 430000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 430400,
        c_title: "衡阳市",
        c_level: 2,
        c_prentId: 430000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 430500,
        c_title: "邵阳市",
        c_level: 2,
        c_prentId: 430000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 430600,
        c_title: "岳阳市",
        c_level: 2,
        c_prentId: 430000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 430700,
        c_title: "常德市",
        c_level: 2,
        c_prentId: 430000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 430800,
        c_title: "张家界市",
        c_level: 2,
        c_prentId: 430000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 430900,
        c_title: "益阳市",
        c_level: 2,
        c_prentId: 430000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 431100,
        c_title: "永州市",
        c_level: 2,
        c_prentId: 430000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 431200,
        c_title: "怀化市",
        c_level: 2,
        c_prentId: 430000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 431300,
        c_title: "娄底市",
        c_level: 2,
        c_prentId: 430000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 433100,
        c_title: "湘西土家族苗族自治州",
        c_level: 2,
        c_prentId: 430000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 420000,
    c_title: "湖北省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 86,
    children: [
      {
        c_id: 420100,
        c_title: "武汉市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 420500,
        c_title: "宜昌市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 420200,
        c_title: "黄石市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 72
      },
      {
        c_id: 420300,
        c_title: "十堰市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 420600,
        c_title: "襄阳市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 420700,
        c_title: "鄂州市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 420800,
        c_title: "荆门市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 420900,
        c_title: "孝感市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 421000,
        c_title: "荆州市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 421100,
        c_title: "黄冈市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 421200,
        c_title: "咸宁市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 421300,
        c_title: "随州市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 422800,
        c_title: "恩施土家族苗族自治州",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 429004,
        c_title: "仙桃市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 429005,
        c_title: "潜江市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 429006,
        c_title: "天门市",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 429021,
        c_title: "神农架林区",
        c_level: 2,
        c_prentId: 420000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 440000,
    c_title: "广东省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 87,
    children: [
      {
        c_id: 440100,
        c_title: "广州市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 441900,
        c_title: "东莞市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 441800,
        c_title: "清远市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 72
      },
      {
        c_id: 440400,
        c_title: "珠海市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 73
      },
      {
        c_id: 440300,
        c_title: "深圳市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 74
      },
      {
        c_id: 440500,
        c_title: "汕头市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 75
      },
      {
        c_id: 440200,
        c_title: "韶关市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 440600,
        c_title: "佛山市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 440700,
        c_title: "江门市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 440800,
        c_title: "湛江市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 440900,
        c_title: "茂名市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 441200,
        c_title: "肇庆市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 441300,
        c_title: "惠州市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 441400,
        c_title: "梅州市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 441500,
        c_title: "汕尾市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 441600,
        c_title: "河源市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 441700,
        c_title: "阳江市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 442000,
        c_title: "中山市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 445100,
        c_title: "潮州市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 445200,
        c_title: "揭阳市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 445300,
        c_title: "云浮市",
        c_level: 2,
        c_prentId: 440000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 450000,
    c_title: "广西",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 88,
    children: [
      {
        c_id: 450100,
        c_title: "南宁市",
        c_level: 2,
        c_prentId: 450000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 450300,
        c_title: "桂林市",
        c_level: 2,
        c_prentId: 450000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 450200,
        c_title: "柳州市",
        c_level: 2,
        c_prentId: 450000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 450400,
        c_title: "梧州市",
        c_level: 2,
        c_prentId: 450000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 450500,
        c_title: "北海市",
        c_level: 2,
        c_prentId: 450000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 450600,
        c_title: "防城港市",
        c_level: 2,
        c_prentId: 450000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 450700,
        c_title: "钦州市",
        c_level: 2,
        c_prentId: 450000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 450800,
        c_title: "贵港市",
        c_level: 2,
        c_prentId: 450000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 450900,
        c_title: "玉林市",
        c_level: 2,
        c_prentId: 450000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 451000,
        c_title: "百色市",
        c_level: 2,
        c_prentId: 450000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 451100,
        c_title: "贺州市",
        c_level: 2,
        c_prentId: 450000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 451200,
        c_title: "河池市",
        c_level: 2,
        c_prentId: 450000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 451300,
        c_title: "来宾市",
        c_level: 2,
        c_prentId: 450000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 451400,
        c_title: "崇左市",
        c_level: 2,
        c_prentId: 450000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 460000,
    c_title: "海南省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 89,
    children: [
      {
        c_id: 460100,
        c_title: "海口市",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 460200,
        c_title: "三亚市",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 460300,
        c_title: "三沙市",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 460400,
        c_title: "儋州市",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469001,
        c_title: "五指山市",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469002,
        c_title: "琼海市",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469005,
        c_title: "文昌市",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469006,
        c_title: "万宁市",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469007,
        c_title: "东方市",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469021,
        c_title: "定安县",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469022,
        c_title: "屯昌县",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469023,
        c_title: "澄迈县",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469024,
        c_title: "临高县",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469025,
        c_title: "白沙黎族自治县",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469026,
        c_title: "昌江黎族自治县",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469027,
        c_title: "乐东黎族自治县",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469028,
        c_title: "陵水黎族自治县",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469029,
        c_title: "保亭黎族苗族自治县",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 469030,
        c_title: "琼中黎族苗族自治县",
        c_level: 2,
        c_prentId: 460000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 510000,
    c_title: "四川省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 91,
    children: [
      {
        c_id: 510100,
        c_title: "成都市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 510300,
        c_title: "自贡市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 510400,
        c_title: "攀枝花市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 510500,
        c_title: "泸州市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 510600,
        c_title: "德阳市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 510700,
        c_title: "绵阳市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 510800,
        c_title: "广元市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 510900,
        c_title: "遂宁市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 511000,
        c_title: "内江市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 511100,
        c_title: "乐山市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 511300,
        c_title: "南充市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 511400,
        c_title: "眉山市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 511500,
        c_title: "宜宾市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 511600,
        c_title: "广安市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 511700,
        c_title: "达州市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 511800,
        c_title: "雅安市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 511900,
        c_title: "巴中市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 512000,
        c_title: "资阳市",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 513200,
        c_title: "阿坝藏族羌族自治州",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 513300,
        c_title: "甘孜藏族自治州",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 513400,
        c_title: "凉山彝族自治州",
        c_level: 2,
        c_prentId: 510000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 530000,
    c_title: "云南省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 92,
    children: [
      {
        c_id: 530100,
        c_title: "昆明市",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 530300,
        c_title: "曲靖市",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 530400,
        c_title: "玉溪市",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 530500,
        c_title: "保山市",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 530600,
        c_title: "昭通市",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 530700,
        c_title: "丽江市",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 530800,
        c_title: "普洱市",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 530900,
        c_title: "临沧市",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 532300,
        c_title: "楚雄彝族自治州",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 532500,
        c_title: "红河哈尼族彝族自治州",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 532600,
        c_title: "文山壮族苗族自治州",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 532800,
        c_title: "西双版纳傣族自治州",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 532900,
        c_title: "大理白族自治州",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 533100,
        c_title: "德宏傣族景颇族自治州",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 533300,
        c_title: "怒江傈僳族自治州",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 533400,
        c_title: "迪庆藏族自治州",
        c_level: 2,
        c_prentId: 530000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 520000,
    c_title: "贵州省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 93,
    children: [
      {
        c_id: 520100,
        c_title: "贵阳市",
        c_level: 2,
        c_prentId: 520000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 520200,
        c_title: "六盘水市",
        c_level: 2,
        c_prentId: 520000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 520300,
        c_title: "遵义市",
        c_level: 2,
        c_prentId: 520000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 520400,
        c_title: "安顺市",
        c_level: 2,
        c_prentId: 520000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 520500,
        c_title: "毕节市",
        c_level: 2,
        c_prentId: 520000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 520600,
        c_title: "铜仁市",
        c_level: 2,
        c_prentId: 520000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 522300,
        c_title: "黔西南布依族苗族自治州",
        c_level: 2,
        c_prentId: 520000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 522600,
        c_title: "黔东南苗族侗族自治州",
        c_level: 2,
        c_prentId: 520000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 522700,
        c_title: "黔南布依族苗族自治州",
        c_level: 2,
        c_prentId: 520000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 540000,
    c_title: "西藏",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 94,
    children: [
      {
        c_id: 540100,
        c_title: "拉萨市",
        c_level: 2,
        c_prentId: 540000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 540200,
        c_title: "日喀则市",
        c_level: 2,
        c_prentId: 540000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 540300,
        c_title: "昌都市",
        c_level: 2,
        c_prentId: 540000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 540400,
        c_title: "林芝市",
        c_level: 2,
        c_prentId: 540000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 540500,
        c_title: "山南市",
        c_level: 2,
        c_prentId: 540000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 540600,
        c_title: "那曲市",
        c_level: 2,
        c_prentId: 540000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 542500,
        c_title: "阿里地区",
        c_level: 2,
        c_prentId: 540000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 610000,
    c_title: "陕西省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 95,
    children: [
      {
        c_id: 610100,
        c_title: "西安市",
        c_level: 2,
        c_prentId: 610000,
        c_special: 0,
        c_sortOrder: 70
      },
      {
        c_id: 610300,
        c_title: "宝鸡市",
        c_level: 2,
        c_prentId: 610000,
        c_special: 0,
        c_sortOrder: 71
      },
      {
        c_id: 610200,
        c_title: "铜川市",
        c_level: 2,
        c_prentId: 610000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 610400,
        c_title: "咸阳市",
        c_level: 2,
        c_prentId: 610000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 610500,
        c_title: "渭南市",
        c_level: 2,
        c_prentId: 610000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 610600,
        c_title: "延安市",
        c_level: 2,
        c_prentId: 610000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 610700,
        c_title: "汉中市",
        c_level: 2,
        c_prentId: 610000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 610800,
        c_title: "榆林市",
        c_level: 2,
        c_prentId: 610000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 610900,
        c_title: "安康市",
        c_level: 2,
        c_prentId: 610000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 611000,
        c_title: "商洛市",
        c_level: 2,
        c_prentId: 610000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 620000,
    c_title: "甘肃省",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 96,
    children: [
      {
        c_id: 620100,
        c_title: "兰州市",
        c_level: 2,
        c_prentId: 620000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 620200,
        c_title: "嘉峪关市",
        c_level: 2,
        c_prentId: 620000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 620300,
        c_title: "金昌市",
        c_level: 2,
        c_prentId: 620000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 620400,
        c_title: "白银市",
        c_level: 2,
        c_prentId: 620000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 620500,
        c_title: "天水市",
        c_level: 2,
        c_prentId: 620000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 620600,
        c_title: "武威市",
        c_level: 2,
        c_prentId: 620000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 620700,
        c_title: "张掖市",
        c_level: 2,
        c_prentId: 620000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 620800,
        c_title: "平凉市",
        c_level: 2,
        c_prentId: 620000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 620900,
        c_title: "酒泉市",
        c_level: 2,
        c_prentId: 620000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 621000,
        c_title: "庆阳市",
        c_level: 2,
        c_prentId: 620000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 621100,
        c_title: "定西市",
        c_level: 2,
        c_prentId: 620000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 621200,
        c_title: "陇南市",
        c_level: 2,
        c_prentId: 620000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 622900,
        c_title: "临夏回族自治州",
        c_level: 2,
        c_prentId: 620000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 623000,
        c_title: "甘南藏族自治州",
        c_level: 2,
        c_prentId: 620000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 640000,
    c_title: "宁夏",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 97,
    children: [
      {
        c_id: 640100,
        c_title: "银川市",
        c_level: 2,
        c_prentId: 640000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 640200,
        c_title: "石嘴山市",
        c_level: 2,
        c_prentId: 640000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 640300,
        c_title: "吴忠市",
        c_level: 2,
        c_prentId: 640000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 640400,
        c_title: "固原市",
        c_level: 2,
        c_prentId: 640000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 640500,
        c_title: "中卫市",
        c_level: 2,
        c_prentId: 640000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 630000,
    c_title: "青海",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 98,
    children: [
      {
        c_id: 630100,
        c_title: "西宁市",
        c_level: 2,
        c_prentId: 630000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 630200,
        c_title: "海东市",
        c_level: 2,
        c_prentId: 630000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 632200,
        c_title: "海北藏族自治州",
        c_level: 2,
        c_prentId: 630000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 632300,
        c_title: "黄南藏族自治州",
        c_level: 2,
        c_prentId: 630000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 632500,
        c_title: "海南藏族自治州",
        c_level: 2,
        c_prentId: 630000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 632600,
        c_title: "果洛藏族自治州",
        c_level: 2,
        c_prentId: 630000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 632700,
        c_title: "玉树藏族自治州",
        c_level: 2,
        c_prentId: 630000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 632800,
        c_title: "海西蒙古族藏族自治州",
        c_level: 2,
        c_prentId: 630000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  },
  {
    c_id: 650000,
    c_title: "新疆",
    c_level: 1,
    c_prentId: 0,
    c_special: 0,
    c_sortOrder: 99,
    children: [
      {
        c_id: 650100,
        c_title: "乌鲁木齐市",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 650200,
        c_title: "克拉玛依市",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 650400,
        c_title: "吐鲁番市",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 650500,
        c_title: "哈密市",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 652300,
        c_title: "昌吉回族自治州",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 652700,
        c_title: "博尔塔拉蒙古自治州",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 652800,
        c_title: "巴音郭楞蒙古自治州",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 652900,
        c_title: "阿克苏地区",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 653000,
        c_title: "克孜勒苏柯尔克孜自治州",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 653100,
        c_title: "喀什地区",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 653200,
        c_title: "和田地区",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 654000,
        c_title: "伊犁哈萨克自治州",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 654200,
        c_title: "塔城地区",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 654300,
        c_title: "阿勒泰地区",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 659001,
        c_title: "石河子市",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 659002,
        c_title: "阿拉尔市",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 659003,
        c_title: "图木舒克市",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 659004,
        c_title: "五家渠市",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 659005,
        c_title: "北屯市",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 659006,
        c_title: "铁门关市",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 659007,
        c_title: "双河市",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 659008,
        c_title: "可克达拉市",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      },
      {
        c_id: 659009,
        c_title: "昆玉市",
        c_level: 2,
        c_prentId: 650000,
        c_special: 0,
        c_sortOrder: 100
      }
    ]
  }
];
const hotIds = [110000, 310000, 500000, 120000];
// const hotIds = [370100,320100,410100,440300];

const hotList = [];
const list = [];
const cityIdsMap = {};
const cityNamesMap = {};
const format = val => {
  val.map(v => {
    cityIdsMap[v.c_id] = v;
    cityNamesMap[v.c_title] = v;
    if (hotIds.indexOf(v.c_id) > -1) {
      hotList.push(v);
    } else if (v.c_level !== 1 && v.c_special !== 1) {
      list.push(v);
    }
    if (v.children) {
      format(v.children);
    }
  });
};
format(data);
const res = { hotList, list };
const getCopyData = () => {
  return JSON.parse(JSON.stringify(res));
};
const getCityInfoByCityName = cityName => {
  return cityNamesMap[cityName];
};
const getAreaData = () => {
  return getCopyData();
};

const getHotAreaData = () => {
  const _area = getCopyData();
  return _area.hotList;
};
const getAreasDataAll = () => {
  const _area = getCopyData();
  return _area.hotList.concat(_area.list);
};

export default {
  getAreaData,
  getHotAreaData,
  getAreasDataAll,
  getCityInfoByCityName
};
